import React from 'react';

const FormSection = ({children}) => {
  return (
    <section className='container'>
        {children}
    </section>
  );
}

export default FormSection;